"use strict";

import axios from "../util/axios";
import { createSelector } from "reselect";
import { SPARE_PARTS } from "@/catalog/constants";
import getCacheBuster from "../util/getCacheBuster";

const prefix = "catalog/all-spare-part-types";

export const FETCH_STARTED = `${prefix}/FETCH_STARTED`;
export const FETCH_FAILED = `${prefix}/FETCH_FAILED`;
export const FETCH_ENDED = `${prefix}/FETCH_ENDED`;

const initialState = {
  isFetching: false,
  data: null,
  error: false,
};

const fetchStart = () => ({ type: FETCH_STARTED });
const fetchEnd = (data) => ({ type: FETCH_ENDED, payload: data });
const fetchFail = () => ({ type: FETCH_FAILED });

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_STARTED:
      return {
        ...state,
        isFetching: true,
        error: false,
      };

    case FETCH_ENDED:
      return {
        ...state,
        data: action.payload,
        isFetching: false,
        error: false,
      };

    case FETCH_FAILED:
      return {
        ...state,
        isFetching: false,
        error: true,
      };

    default:
      return state;
  }
}

const sparePartTypesSelector = (state) => state.allSparePartTypes;

export const getIsAllSparePartTypesFetching = createSelector(sparePartTypesSelector, (data) => data.isFetching);

export const getAllSparePartTypes = createSelector(sparePartTypesSelector, (data) => data.data || []);

export const getHasSparePartTypesFetched = createSelector(getAllSparePartTypes, (sparePartTypes) => sparePartTypes.length > 0);

function fetchSparePartTypes(filter) {
  return (dispatch) => {
    dispatch(fetchStart(filter));
    axios
      .get("api/category/", { params: { _: getCacheBuster(), partType: SPARE_PARTS } })
      .then((res) => {
        dispatch(fetchEnd(res.data));
      })
      .catch(() => {
        dispatch(fetchFail());
      });
  };
}

export function fetchAllSparePartTypes() {
  return (dispatch, getState) => {
    const state = getState();
    const data = getAllSparePartTypes(state);

    if (!getIsAllSparePartTypesFetching(state) && data.length === 0) {
      dispatch(fetchSparePartTypes());
    }
  };
}
